<div class="agpr-external-data-source-picker-field" role="group" [attr.aria-labelledby]="field.headingId">

  <div class="agpr-external-data-source-picker-field-inputRow">
    <!-- @TODO future thing, non google analytics sources
    <agpr-checkbox
      [id]="id"
      [binary]="true"
      [(ngModel)]="useGoogleAnalyticsReferralSource"
      checked
    >
    </agpr-checkbox>
    -->
    <agpr-dropdown
      [id]="id + '.dataConnectorOptions'"
      class="agpr-external-data-source-picker-field-dropdown"
      [placeholder]="'Reports.chooseDataSource'"
      [options]="externalDataSourceOptions"
      [(ngModel)]="selectedExternalDataSource"
      (ngModelChange)="handleExternalDataSourceSelection($event)"
      label="Reports.googleAnalyticsReferralSource"
    ></agpr-dropdown>
  </div>

  <div class="agpr-external-data-source-picker-field-inputRow">
    <agpr-autocomplete
      [id]="id + '.accountOptions'"
      class="agpr-external-data-source-picker-field-autocomplete"
      [dropdown]="true"
      [clearOnBlur]="false"
      [suggestions]="googleAnalyticsAccountOptions$"
      label="Reports.account"
      placeholder="Reports.selectGoogleAnalyticsAccount"
      labelField="name"
      [disabled]="!selectedExternalDataSource"
      [(ngModel)]="selectedGoogleAnalyticsAccount"
      (ngModelChange)="handleGoogleAnalyticsAccountChange($event)"
    ></agpr-autocomplete>
  </div>

  <div class="agpr-external-data-source-picker-field-inputRow">
    <agpr-autocomplete
      [id]="id + '.propertyOptions'"
      class="agpr-external-data-source-picker-field-autocomplete"
      [dropdown]="true"
      [clearOnBlur]="false"
      [suggestions]="propertyOptions$"
      label="Reports.property"
      placeholder="Reports.selectProperty"
      labelField="displayName"
      [disabled]="!selectedExternalDataSource || !selectedGoogleAnalyticsAccount || propertyOptions$.value.length === 0"
      [(ngModel)]="selectedProperty"
      (ngModelChange)="handlePropertyChange($event)"
    ></agpr-autocomplete>
  </div>

  <div
    *ngIf="selectedExternalDataSource?.value.type !== googleAnalyticsTypes.GOOGLE_ANALYTICS_4"
    class="agpr-external-data-source-picker-field-inputRow"
  >
    <agpr-autocomplete
      [id]="id + '.viewOptions'"
      class="agpr-external-data-source-picker-field-autocomplete"
      [dropdown]="true"
      [suggestions]="viewOptions$"
      [clearOnBlur]="false"
      label="Reports.view"
      placeholder="Reports.selectView"
      labelField="name"
      [disabled]="!selectedExternalDataSource || !selectedGoogleAnalyticsAccount || !selectedProperty || viewOptions$.value?.length === 0"
      ariaLabelledBy="externalDataSourcePickerField_viewAutocompleteLabel"
      [(ngModel)]="selectedView"
      (ngModelChange)="handleViewChange($event)"
    ></agpr-autocomplete>
  </div>
</div>
